<template>
<!-- 咨询经历 -->
  <div class="experience-main">
      <div class="bar"><div></div></div>
      <div class="textarea-main">
          <div class="title"><span></span>咨询主题</div>
          <textarea  v-model="form.label1" placeholder="请输入：" ></textarea>
      </div>
        <!--  -->
      <div class="footer">
          <button @click="saveHandle()">下一步</button>
      </div>
  </div>
</template>

<script>
import { orderList,counsellingSetReport } from "@/api/xuandui_gadgets"
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            place:'',
            text:'',
            pages:{},
            list:[],
            keys:{
                label1:'咨询主题',
                profession:'职业类型',
                industry:'所在行业',
                job_content:'工作内容'
            },
            form:{
                label1:''
            },
        }
    },
    methods:{
        // 提交资料
        saveHandle(){
            let fild = Object.keys(this.form);
            let arr = [];
            fild.map(v=>{
                if(!this.form[v]){
                    this.$toast('信息不能为空！');
                    return
                }
                arr.push({
                    label:this.keys[v],
                    value:this.form[v]
                });
            });
            let info = JSON.parse(this.list[0].report)?JSON.parse(this.list[0].report):[];
            let arrlist = [arr,...info];
            // 提交数据
            counsellingSetReport({
                order_id:this.list[0].id,
                report:JSON.stringify(arrlist)
            }).then((data)=>{
                if(data.error>0){
                    this.$toast(data.detail || data.msg);
                    return
                }
                this.$toast('保存成功！');
                // this.$router.push('/xd_ef');
            });
        },
        // 初始化获取数据
        pullData(){
            document.title = '咨询主题';
            //调用加载中
            this.$emit('loadingHandle',true,"拼命加载中...");
            let q = this.$route.query;
            let obj = {
                page:this.pages.page,  //页码，默认1
                size:this.pages.size,   //每页数量，默认10
                category_id:2,//做自己节传1,选对小工具传2
                status:1,
                id:q.oid
            };
            orderList(obj).then((data)=>{
                    //关闭加载中
                this.$emit('loadingHandle',false);
                if(data.error>0){
                    this.$toast(data.detail || data.msg);
                    return
                }
                this.pages = data.pager;
                
                this.list = data.list;
                // let corporate_name = getStorage('/xd_add_experience','corporate_name');
                // let profession = getStorage('/xd_add_experience','profession');
                // let industry = getStorage('/xd_add_experience','industry');
                // let job_content = getStorage('/xd_add_experience','job_content');
                // // 判断是第几个职业经历，没有则为第一个
                // if(q.eidx || q.eidx==0){
                //     this.experience_idx = q.eidx;
                //     let info = JSON.parse(this.list[0].collection)?JSON.parse(this.list[0].collection):[];
                //     let keys_ = Object.keys(this.keys);
                //     if(info[0]){
                        
                //         info[0].value[this.experience_idx].map((v,idx)=>{
                //             keys_.map((k,kidx)=>{
                //                 // 时间
                //                 if(v.label=='时间'){
                //                     this.time = v.value.split('^');
                //                 }else{
                //                     if(v.label==this.keys[k]){
                //                         this.form[k] = v.value;
                //                     }
                //                 }
                                
                //             });
                //         });
                //     }
                    
                // }
                // if(!this.form.corporate_name && corporate_name){
                //     this.form.corporate_name = corporate_name;
                // } 
                // if(!this.form.profession && profession){
                //     this.form.profession = profession;
                // }
                // if(!this.form.industry && industry){
                //     this.form.industry = industry;
                // } 
                // if(!this.form.job_content && job_content){
                //     this.form.job_content = job_content;
                // }
                


                // 处理年份数据
                // if(this.columns.length<=0){
                //     let date = new Date();
                //     let yesr_ = date.getFullYear(); //获取完整的年份(4位)
                //     let arr = [];
                //     for(let i=yesr_;i>=1900;i--){
                //         arr.push(i);
                //     }
                    
                //     this.columns = [// 第一列 年份
                //         {
                //             values: arr,
                //             defaultIndex: 2,
                //         },
                //         // 第二列 月份
                //         {
                //             values: [1,2,3,4,5,6,7,8,9,10,11,12],
                //             defaultIndex: 1,
                //         }
                //     ];
                // }
            })
            shareCon('index',this);
        }
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss">
    body{
        background-color: #ffffff;
    }
</style>
<style lang="scss" scoped>
    .experience-main{
        padding: 0px 0px 140px;
        .bar{
            background-color: #ECECEC;
            height: 8px;
            div{
                width: 200px;
                height: 100%;
                background: #46A3FA;
            }
        }
        .textarea-main{
            font-size: 30px;
            background: #FFFFFF;
            border-radius: 20px;
            position: relative;
            padding: 46px 30px;
            .title{
                font-weight: bold;
                color: #2B333A;
                font-size: 30px;
                margin-bottom: 26px;
                display: flex;
                span{
                    width: 6px;
                    height: 30px;
                    background: #46A3FA;
                    border-radius: 6px;
                    margin-right: 20px;
                    margin-top: 8px;
                }
            }
            textarea{
                width: 100%;
                min-height: 700px;
                font-size: 30px;
                border-radius: 20px;
                padding: 36px 30px;
                outline: none;
                resize: none;
                border: none;
                background: #F7F8F9;
            }
        }
        .footer{
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: fixed;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            max-width: 750px;
            background-color: #FFFFFF;
            button{
                width: 670px;
                height: 80px;
                background: #46A3FA;
                border-radius: 40px;
                font-size: 32px;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 44px;
                letter-spacing: 1px;
                border: none;
            }
        }
    }
</style>